// Development diagnostic component
import { useEffect, useState } from 'react'
import { apiClient } from '@/lib/api'

export default function DevDiagnostics() {
  const [diagnostics, setDiagnostics] = useState<any>({})
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Only show when explicitly enabled via ?debug=true query param
    const shouldShow = window.location.search.includes('debug=true')
    
    if (shouldShow) {
      setIsVisible(true)
      
      // Collect diagnostic information
      const info = {
        timestamp: new Date().toISOString(),
        location: window.location.href,
        userAgent: navigator.userAgent,
        environment: {
          hoardURL: (import.meta as any).env?.VITE_HOARD_API_URL,
          loginImageURL: (import.meta as any).env?.VITE_LOGIN_IMAGE_URL,
          mode: (import.meta as any).env?.MODE,
          dev: (import.meta as any).env?.DEV,
          prod: (import.meta as any).env?.PROD,
        },
        apiClientType: apiClient.constructor.name
      }
      
      setDiagnostics(info)
    }
  }, [])

  const testAPICall = async () => {
    try {
      const response = await fetch('/panel/api/client', {
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      
      const result: any = {
        status: response.status,
        statusText: response.statusText,
        headers: Object.fromEntries([...response.headers.entries()]),
        url: response.url
      }
      
      if (response.ok) {
        try {
          result.data = await response.json()
        } catch {
          result.text = await response.text()
        }
      }
      
      setDiagnostics((prev: any) => ({ ...prev, apiTest: result }))
    } catch (error: any) {
      setDiagnostics((prev: any) => ({ ...prev, apiTest: { error: error?.message || String(error) } }))
    }
  }

  if (!isVisible) return null

  return (
    <div className="fixed bottom-4 right-4 max-w-md bg-gray-900 text-white p-4 rounded-lg shadow-lg text-xs font-mono z-50 max-h-96 overflow-auto">
      <div className="flex justify-between items-center mb-2">
        <span className="font-bold text-green-400">Dev Diagnostics</span>
        <button
          onClick={() => setIsVisible(false)}
          className="text-gray-400 hover:text-white"
        >
          ×
        </button>
      </div>
      
      <div className="space-y-2">
        <div>
          <div className="text-blue-400">Environment:</div>
          <pre className="text-xs overflow-auto">{JSON.stringify(diagnostics.environment, null, 2)}</pre>
        </div>
        
        <div>
          <div className="text-blue-400">API Client: {diagnostics.apiClientType}</div>
        </div>
        
        <div>
          <div className="text-blue-400">Location: {diagnostics.location}</div>
        </div>
        
        <button
          onClick={testAPICall}
          className="bg-blue-600 hover:bg-blue-700 px-2 py-1 rounded text-xs"
        >
          Test API Call
        </button>
        
        {diagnostics.apiTest && (
          <div>
            <div className="text-blue-400">API Test Result:</div>
            <pre className="text-xs overflow-auto bg-gray-800 p-2 rounded">
              {JSON.stringify(diagnostics.apiTest, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  )
}
